var map = {
	"./404.vue": 1706,
	"./About.vue": 94410,
	"./ContactUs.vue": 75671,
	"./IFrameDailyPuzzle.vue": 5977,
	"./LogicDay.vue": 49427,
	"./PrivacyPolicy.vue": 60232,
	"./SAMFTalentSearch.vue": 72928,
	"./TermsConditions.vue": 72587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57057;